import { CheckpointOperationType } from '../enums/checkpoint-operation-type.enum';

export interface IManualOutlierOutputDto {
    id: string;
    stat: string;
    tripCode: string;
    locationId?: string;
    operationType?: CheckpointOperationType;
}

export interface IUpsertManualOutlierDto {
    stat: string;
    tripCode: string;
    locationId?: string;
    operationType?: CheckpointOperationType;
}
